const VALID_THEMES = new Set(["light", "dark"]);

const getThemeRuntime = () => {
    const runtime = window.rcdTheme;

    if (!runtime) {
        throw new Error("RCD Theme runtime must be initialized before the application bundle.");
    }

    return runtime;
};

export const createRcdThemeState = ({ defaultTheme = "dark", onChange } = {}) => {
    const runtime = getThemeRuntime();
    const initialTheme = runtime.get(defaultTheme);

    return {
        theme: initialTheme,
        _unsubscribeTheme: null,
        initTheme() {
            const resolvedTheme = runtime.get(defaultTheme);

            if (this.theme !== resolvedTheme) {
                this.theme = resolvedTheme;
            }

            runtime.set(resolvedTheme, {
                notify: false,
                persist: false,
                source: "alpine-init"
            });

            this._unsubscribeTheme?.();
            this._unsubscribeTheme = runtime.subscribe(({ theme }) => {
                if (this.theme !== theme) {
                    this.theme = theme;
                }
            });

            this.$watch("theme", (value) => {
                if (!VALID_THEMES.has(value)) {
                    this.theme = runtime.get(defaultTheme);
                    return;
                }

                runtime.set(value, { source: "alpine" });
                onChange?.call(this, value);
            });
        },
        toggleTheme() {
            this.theme = this.theme === "dark" ? "light" : "dark";
        }
    };
};

window.rcdThemeState = Object.freeze({
    create: createRcdThemeState
});
